import React, { memo } from 'react';

import DroppedIceCream from '../../assets/dropped-icecream.svg';

export default memo(props => (
  <DroppedIceCream
    alt="dropped ice cream melting on the ground"
    data-testid="dropped-ice-cream-icon"
    {...props}
  />
));
